import * as Yup from 'yup'

export const validationSchema = Yup.object().shape({
  declineOptionId: Yup.number().nullable(),
  comment: Yup.string()
    .label('Comment')
    .when('declineOptionId', {
      is: null,
      then: (schema) => schema.required('Comment is required'),
      otherwise: (schema) => schema.notRequired(),
    }),
})
